import { createSlice } from '@reduxjs/toolkit';

import { getDeserializedState } from 'FRONTEND/utils/serialization';

const REDUCER_NAME = 'rightPanel';
const storedState = getDeserializedState()?.[REDUCER_NAME];

const rightPanelInitialState = {
  isShown: storedState?.isShown || false,
  isMaxExtended: storedState?.isMaxExtended || false,
  isExtended: storedState?.isExtended || false,
  isVideoConferenceReady: false,
  videoConferenceUrl: null,
};

const rightPanelSlice = createSlice({
  name: REDUCER_NAME,
  initialState: rightPanelInitialState,
  reducers: {
    videoconferenceReady(state, { payload }) {
      state.isVideoConferenceReady = true;
      state.videoConferenceUrl = payload.videoConferenceUrl;
    },
    endVideoConference(state) {
      state.isVideoConferenceReady = false;
      state.videoConferenceUrl = null;
      state.isExtended = false;
    },
    showRightPanel(state) {
      state.isShown = true;
    },
    hideRightPanel(state) {
      state.isShown = false;
    },
    maxExtendRightPanel(state) {
      state.isMaxExtended = true;
    },
    maxReduceRightPanel(state) {
      state.isMaxExtended = false;
    },
    extendRightPanel(state) {
      state.isExtended = true;
    },
    reduceRightPanel(state) {
      state.isExtended = false;
    },
    joinConfRoom(state, { payload: { videoConferenceUrl } }) {
      state.isShown = true;
      state.isExtended = true;
      state.isVideoConferenceReady = true;
      state.videoConferenceUrl = videoConferenceUrl;
    },
  },
});

export const {
  showRightPanel,
  hideRightPanel,
  maxExtendRightPanel,
  maxReduceRightPanel,
  extendRightPanel,
  reduceRightPanel,
  videoconferenceReady,
  endVideoConference,
  joinConfRoom,
} = rightPanelSlice.actions;
export default rightPanelSlice.reducer;
